import { useState } from 'react';
import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroBoard from '@/pages/home/components/HeroBoard';
import LiveFeed from '@/pages/home/components/LiveFeed';
import HeatRanking from '@/pages/home/components/HeatRanking';
import ReversalTracker from '@/pages/home/components/ReversalTracker';
import TopicBoard from '@/pages/home/components/TopicBoard';
import EditorPicks from '@/pages/home/components/EditorPicks';
import UpdateReminder from '@/pages/home/components/UpdateReminder';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  const [activeTopic, setActiveTopic] = useState('全部');

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main className="w-full">
        <HeroBoard />
        <LiveFeed activeTopic={activeTopic} onChangeTopic={setActiveTopic} />
        <HeatRanking />
        <ReversalTracker />
        <TopicBoard />
        <EditorPicks />
        <UpdateReminder />
      </main>
      <SiteFooter />
    </div>
  );
}